export default "__VITE_ASSET__BjSNQbKs__"